import { Injectable, inject, signal } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { finalize, tap } from 'rxjs';
import { AuthResponse, CustomerRegisterRequest, LoginRequest } from '../../../models/auth.types';
import { USE_ADMIN_API } from '../../interceptors/api.context'; // <-- Updated import
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);

  isSubmitting = signal(false);
  currentUser = signal<any>(null); // Store user data after login
  userProfile = signal<any>(null);
  // --- REGISTRATION (Uses Admin API) ---
  registerCustomer(payload: any) {
    this.isSubmitting.set(true);

    return this.http
      .post('/api/v1/customers/register', payload, {
        // FIX: Explicitly request the Admin API just for this call
        context: new HttpContext().set(USE_ADMIN_API, true),
      })
      .pipe(finalize(() => this.isSubmitting.set(false)));
  }
  isLoggedIn() {
    return !!localStorage.getItem('authToken');
  }


  login(credentials: LoginRequest) {
    this.isSubmitting.set(true);
    return this.http.post<AuthResponse>('/api/v1/login', credentials).pipe(
      tap((res) => {
        // FIX: Access token via res.data.token
        if (res.success && res.data?.token) {
          localStorage.setItem('authToken', res.data.token); // Store raw token
          this.currentUser.set(res.data.user);
        }
      }),
      finalize(() => this.isSubmitting.set(false)),
    );
  }

  getUserDetails() {
    return this.http.get<any>('/api/v1/user_details').pipe(tap((res) => this.userProfile.set(res)));
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login']);
    this.currentUser.set(null);
  }
}


  // --- LOGIN (Uses Default Ming Client API) ---
  // login(credentials: LoginRequest) {
  //   this.isSubmitting.set(true);

  //   // FIX: No context needed here anymore. It defaults to ming_client
  //   return this.http.post<AuthResponse>('/api/v1/login', credentials).pipe(
  //     tap(res => {
  //       if (res.token) {
  //         localStorage.setItem('currentUser', JSON.stringify(res.token));
  //         this.currentUser.set(res.user);
  //       }
  //     }),
  //     finalize(() => this.isSubmitting.set(false))
  //   );
  // }
